import type { BriefData, FootageData, StoryboardFrameData, StoryboardSettings } from './types'

const baseSourceFrames: StoryboardFrameData[] = [
  {
    id: '1',
    image:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=500&fit=crop',
    timeStart: '00:00',
    timeEnd: '00:01',
    label: 'Hook',
    description: 'Close this out!',
    textOverlay: 'Close this out!',
    audioText: 'And it stays perfect all day',
  },
  {
    id: '2',
    image:
      'https://images.unsplash.com/photo-1524502397800-2eeaad7c3fe5?w=400&h=500&fit=crop',
    timeStart: '00:01',
    timeEnd: '00:03',
    label: 'Benefit',
    description: 'I just put this bra on in the morning',
    textOverlay: 'I just put this bra on in the morning',
    audioText: 'I just put this bra on in the morning',
  },
  {
    id: '3',
    image:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=500&fit=crop',
    timeStart: '00:03',
    timeEnd: '00:04',
    label: 'Pain',
    description: 'No wires digging in.',
    textOverlay: 'No wires digging in.',
    audioText: 'No wires digging in.',
  },
  {
    id: '4',
    image:
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=500&fit=crop',
    timeStart: '00:05',
    timeEnd: '00:05',
    label: 'Pain',
    description: 'No clipping straps.',
    textOverlay: 'No clipping straps.',
    audioText: 'No clipping straps.',
  },
  {
    id: '5',
    image:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=500&fit=crop',
    timeStart: '00:06',
    timeEnd: '00:06',
    label: 'Pain',
    description: 'No annoying adjustments.',
    textOverlay: 'No annoying adjustments',
    audioText: 'No annoying adjustments',
  },
  {
    id: '6',
    image:
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=500&fit=crop',
    timeStart: '00:07',
    timeEnd: '00:08',
    label: 'Solution',
    description: 'Let me show you why',
    textOverlay: 'Let me show you why',
    audioText: 'This is my go to',
  },
]

const benchmarkFrameSets: StoryboardFrameData[][] = [
  [
    {
      id: 'b1',
      image:
        'https://images.unsplash.com/photo-1485178575877-1a13bf489dfe?w=400&h=500&fit=crop',
      timeStart: '00:00',
      timeEnd: '00:01',
      label: 'Hook',
      description: 'Close this out!',
      textOverlay: 'Close this out!',
      audioText: 'I just put this bra on in the morning',
    },
    {
      id: 'b2',
      image:
        'https://images.unsplash.com/photo-1499996860823-5214fcc65f8f?w=400&h=500&fit=crop',
      timeStart: '00:01',
      timeEnd: '00:03',
      label: 'Benefit',
      description: 'I just put this bra on in the morning',
      textOverlay: 'I just put this bra on in the morning',
      audioText: 'And it stays perfect all day',
    },
    {
      id: 'b3',
      image:
        'https://images.unsplash.com/photo-1479936343636-73cdc5aae0c3?w=400&h=500&fit=crop',
      timeStart: '00:03',
      timeEnd: '00:04',
      label: 'Pain',
      description: 'No wires digging in.',
      textOverlay: 'No wires digging in.',
      audioText: 'No wires digging in.',
    },
    {
      id: 'b4',
      image:
        'https://images.unsplash.com/photo-1513721032312-6a18a42c8763?w=400&h=500&fit=crop',
      timeStart: '00:05',
      timeEnd: '00:05',
      label: 'Pain',
      description: 'No clipping straps.',
      textOverlay: 'No clipping straps.',
      audioText: 'No clipping straps.',
    },
    {
      id: 'b5',
      image:
        'https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?w=400&h=500&fit=crop',
      timeStart: '00:06',
      timeEnd: '00:06',
      label: 'Pain',
      description: 'No annoying adjustments.',
      textOverlay: 'No annoying adjustments',
      audioText: 'No annoying adjustments',
    },
    {
      id: 'b6',
      image:
        'https://images.unsplash.com/photo-1506089676908-3592f7389d4d?w=400&h=500&fit=crop',
      timeStart: '00:07',
      timeEnd: '00:08',
      label: 'Solution',
      description: 'Let me show you why this is my go to',
      textOverlay: 'Let me show you why',
      audioText: 'This is my go to',
    },
  ],
  [
    {
      id: 'b1',
      image:
        'https://images.unsplash.com/photo-1524638431109-93d95c968f03?w=400&h=500&fit=crop',
      timeStart: '00:00',
      timeEnd: '00:01',
      label: 'Hook',
      description: 'Why this is your best fit',
      textOverlay: 'Why this is your best fit',
      audioText: 'This bra is different from the start',
    },
    {
      id: 'b2',
      image:
        'https://images.unsplash.com/photo-1528892952291-009c663ce843?w=400&h=500&fit=crop',
      timeStart: '00:01',
      timeEnd: '00:03',
      label: 'Benefit',
      description: 'Support that lifts without squeezing',
      textOverlay: 'Support that lifts',
      audioText: 'Support that lifts without squeezing',
    },
    {
      id: 'b3',
      image:
        'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=400&h=500&fit=crop',
      timeStart: '00:03',
      timeEnd: '00:04',
      label: 'Pain',
      description: 'No wires digging in.',
      textOverlay: 'No wires digging in.',
      audioText: 'No wires digging in.',
    },
    {
      id: 'b4',
      image:
        'https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=400&h=500&fit=crop',
      timeStart: '00:05',
      timeEnd: '00:05',
      label: 'Pain',
      description: 'No clipping straps.',
      textOverlay: 'No clipping straps.',
      audioText: 'No clipping straps.',
    },
    {
      id: 'b5',
      image:
        'https://images.unsplash.com/photo-1541271696563-3be2f555fc4e?w=400&h=500&fit=crop',
      timeStart: '00:06',
      timeEnd: '00:06',
      label: 'Benefit',
      description: 'Feels invisible all day',
      textOverlay: 'Feels invisible all day',
      audioText: 'Feels invisible all day',
    },
    {
      id: 'b6',
      image:
        'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=500&fit=crop',
      timeStart: '00:07',
      timeEnd: '00:08',
      label: 'CTA',
      description: 'Get yours today',
      textOverlay: 'Get yours today',
      audioText: 'Get yours today',
    },
  ],
  [
    {
      id: 'b1',
      image:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop',
      timeStart: '00:00',
      timeEnd: '00:01',
      label: 'Hook',
      description: 'Winter sale, limited time',
      textOverlay: 'Winter sale',
      audioText: 'Winter sale',
    },
    {
      id: 'b2',
      image:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop',
      timeStart: '00:01',
      timeEnd: '00:03',
      label: 'Benefit',
      description: 'A flexible fit that adapts',
      textOverlay: 'A flexible fit that adapts',
      audioText: 'That adapts to your body',
    },
    {
      id: 'b3',
      image:
        'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=500&fit=crop',
      timeStart: '00:03',
      timeEnd: '00:04',
      label: 'Benefit',
      description: 'Butter soft fabric',
      textOverlay: 'Butter soft fabric',
      audioText: 'That feels you comfortable',
    },
    {
      id: 'b4',
      image:
        'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=400&h=500&fit=crop',
      timeStart: '00:05',
      timeEnd: '00:05',
      label: 'Benefit',
      description: "It's truly the bra you've been wearing.",
      textOverlay: "It's truly the bra",
      audioText: "You've been wearing.",
    },
    {
      id: 'b5',
      image:
        'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7?w=400&h=500&fit=crop',
      timeStart: '00:06',
      timeEnd: '00:06',
      label: 'Benefit',
      description: "You'll forget you're even wearing",
      textOverlay: "You'll forget you're even wearing",
      audioText: "You'll forget you're even wearing",
    },
    {
      id: 'b6',
      image:
        'https://images.unsplash.com/photo-1507152832244-10d45c7eda57?w=400&h=500&fit=crop',
      timeStart: '00:07',
      timeEnd: '00:08',
      label: 'CTA',
      description: 'Shop now 50% off',
      textOverlay: 'Shop now 50% off',
      audioText: 'Shop now',
    },
  ],
]

export const mockFootageRepository: FootageData[] = [
  {
    id: '1',
    filename: 'SHM_GABRIELA_EBRA_2025_001',
    thumbnail: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158',
    duration: '0:07',
  },
  {
    id: '2',
    filename: 'SHM_GABRIELA_EBRA_2025_002',
    thumbnail: 'https://images.unsplash.com/photo-1581092795360-fd1ca04f0952',
    duration: '0:10',
  },
  {
    id: '3',
    filename: 'SHM_JULIA_EBRA_2025_003',
    thumbnail: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837',
    duration: '0:01',
  },
  {
    id: '4',
    filename: 'SHM_JULIA_EBRA_2025_004',
    thumbnail: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789',
    duration: '0:05',
  },
  {
    id: '5',
    filename: 'SHM_GABRIELA_EBRA_2025_005',
    thumbnail: 'https://images.unsplash.com/photo-1581092795442-31d9d15e4e19',
    duration: '0:08',
  },
  {
    id: '6',
    filename: 'SHM_GABRIELA_EBRA_2025_006',
    thumbnail: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758',
    duration: '0:12',
  },
]

export const mockBriefData: BriefData = {
  productName: 'SkinGlow Pro Serum',
  targetAudience: 'Women 25-45 interested in skincare and anti-aging',
  mainBenefit: 'Visibly reduces wrinkles in 2 weeks',
  painPoints: [
    'Fine lines and wrinkles',
    'Dull, tired-looking skin',
    "Expensive treatments that don't work",
  ],
  tone: 'Professional yet approachable, confidence-boosting',
  callToAction: 'Get 50% off your first order',
  keyMessages: [
    'Clinically proven formula',
    'Natural ingredients',
    'Results in 14 days or money back',
  ],
  videoLength: '30 seconds',
  platform: 'TikTok / Instagram Reels',
}

export const mockStoryboardSettings: StoryboardSettings = {
  name: 'Q1 Campaign Storyboard',
  createdAt: '2024-01-15',
  lastModified: '2024-01-20',
  aspectRatio: '4:5',
  duration: '30 seconds',
  targetPlatform: 'Instagram Reels',
  style: 'Modern / Minimalist',
  audioTrack: 'Upbeat Corporate',
  language: 'English',
  status: 'In Progress',
}

export const mockVersions = [
  { id: 1, name: 'Version 1', date: '2 hours ago' },
  { id: 2, name: 'Version 2', date: '1 day ago' },
  { id: 3, name: 'Version 3', date: '2 days ago' },
]

const cloneFrames = (frames: StoryboardFrameData[]) => frames.map(frame => ({ ...frame }))

export const getSourceFrames = () => cloneFrames(baseSourceFrames)

export const getBenchmarkFrames = (versionId: number) => {
  const index = (versionId - 1) % benchmarkFrameSets.length
  return cloneFrames(benchmarkFrameSets[index])
}
